import { MaterialUICore } from '@iclinic/design-system';

const { makeStyles } = MaterialUICore;

export default makeStyles(() => ({
  container: { display: 'flex' },
  fields: { flexGrow: 1 },
}));
